import React from "react";
import { Link } from "react-router-dom";
import SubNavContainer from "../../../components/SubNavContainer";
import SectionCard from "../../../components/SectionCard";

import headerpic from "../../../assets/header-images/headerpic.png";
import "../../../css/SubPage/SubPage.css";

import apprentice from "../../../assets/header-images/apprentice.jpg";

function Apprenticeship() {
  const programsData = [
    {
      subtitle: "Google Apprenticeships:",
      description:
        "Google offers a variety of apprenticeships designed to help individuals gain hands-on experience and develop skills in fields like IT, software engineering, and data analysis. Participants receive mentorship and support to thrive in their chosen career paths!",
      website: "Google Apprenticeships",
      websiteUrl: "https://buildyourfuture.withgoogle.com/apprenticeships",
    },
    {
      subtitle: "Microsoft Leap:",
      description:
        "The Microsoft Leap program provides an immersive 16-week experience for individuals seeking to develop technical skills and start a career in technology. With training, mentorship, and hands-on projects, participants are well-prepared for full-time roles at Microsoft and beyond!",
      website: "Microsoft Leap",
      websiteUrl: "https://leap.microsoft.com/en-US/",
    },
    {
      subtitle: "Adobe Digital Academy:",
      description:
        "This partnership between Adobe and General Assembly offers an apprenticeship program that combines training in digital skills with real-world experience at Adobe. Participants learn coding, design, and data science, followed by an impactful apprenticeship at Adobe!",
      website: "Adobe Digital Academy",
      websiteUrl: "https://learn.generalassemb.ly/adobe-digital-academy/",
    },
    {
      subtitle: "IBM Apprenticeships:",
      description:
        "IBM offers a range of apprenticeship programs in software development, cybersecurity, and data science. These programs provide hands-on experience, mentorship, and opportunities to work on exciting projects at IBM, setting you on a path to success!",
      website: "IBM Apprenticeships",
      websiteUrl: "https://www.ibm.com/careers/career-opportunities",
    },
    {
      subtitle: "LinkedIn Reach:",
      description:
        "LinkedIn Reach is an apprenticeship program designed to help individuals from diverse backgrounds gain skills in software engineering. This program includes training, mentorship, and real-world project experience to prepare participants for full-time roles at LinkedIn and other tech companies!",
      website: "LinkedIn Reach",
      websiteUrl: "https://careers.linkedin.com/reach",
    },
    {
      subtitle: "Lyft Early Talent:",
      description:
        "Lyft's apprenticeship program offers opportunities for individuals to gain experience in software engineering, data science, and other technical fields. Participants receive training, mentorship, and hands-on projects to kickstart their careers!",
      website: "Lyft Early Talent",
      websiteUrl: "https://www.lyft.com/careers/early-talent",
    },
    {
      subtitle: "Uber University:",
      description:
        "Uber offers a variety of apprenticeship programs to help individuals gain experience in technology and engineering. Participants receive training, mentorship, and hands-on project experience to prepare them for fulfilling careers at Uber!",
      website: "Uber University",
      websiteUrl: "https://www.uber.com/us/en/careers/teams/university/",
    },
    {
      subtitle: "Airbnb Connect Engineering Apprenticeship:",
      description:
        "The Airbnb Connect Engineering Apprenticeship is designed to help underrepresented individuals gain skills in software engineering. This program includes training, mentorship, and project work at Airbnb, preparing participants for exciting careers!",
      website: "Airbnb Connect Engineering Apprenticeship",
      websiteUrl:
        "https://careers.airbnb.com/connect-engineering-apprenticeship/",
    },
    {
      subtitle: "Pinterest Apprenticeships:",
      description:
        "Pinterest offers apprenticeship programs in software engineering, data science, and other technical fields. Participants receive training, mentorship, and hands-on experience to develop their skills and start their careers at Pinterest and beyond!",
      website: "Pinterest Apprenticeships",
      websiteUrl:
        "https://www.pinterestcareers.com/early-career/apprenticeships/",
    },
    {
      subtitle: "Snapchat University:",
      description:
        "Snapchat's apprenticeship program provides opportunities for individuals to gain experience in software engineering and other technical fields. The program includes training, mentorship, and real-world project work at Snapchat, a fantastic place to grow your career!",
      website: "Snapchat University",
      websiteUrl: "https://careers.snap.com/university",
    },
    {
      subtitle: "Accenture Apprenticeships:",
      description:
        "Accenture and Aon have partnered to offer apprenticeship programs that provide hands-on experience and training in various fields, including technology and consulting. Participants receive mentorship and support to thrive in their careers!",
      website: "Accenture Apprenticeships",
      websiteUrl:
        "https://www.accenture.com/us-en/about/company/apprenticeships",
    },
    {
      subtitle: "Apprenti:",
      description:
        "Apprenti offers apprenticeship programs in technology, providing training and job placement in fields such as software development, cybersecurity, and IT. This program aims to bridge the gap between education and employment for underrepresented individuals!",
      website: "Apprenti",
      websiteUrl: "https://apprenticareers.org/apply/",
    },
    {
      subtitle: "Catalyte Apprenticeships:",
      description:
        "Catalyte's apprenticeship program focuses on software development, providing training and hands-on experience to help individuals start their careers in tech. Participants work on real projects and receive mentorship to cultivate their skills!",
      website: "Catalyte Apprenticeships",
      websiteUrl:
        "https://www.catalyte.io/apprenticeships/software-development/",
    },
    {
      subtitle: "Multiverse Programs:",
      description:
        "Multiverse offers apprenticeship programs that combine on-the-job training with formal learning, helping individuals develop technical skills and kickstart their careers. The focus is on creating pathways to tech jobs for people from diverse backgrounds!",
      website: "Multiverse Programs",
      websiteUrl: "https://www.multiverse.io/us/apprenticeships",
    },
  ];

  return (
    <div id="newest-background">
      <div id="Ch-face">
        <img id="header-image" src={apprentice} />
        <div id="TOC-face-text-container">
          <div id="TOC-face-text">
            <p className="TOC-header-text"> Apprenticeship Programs </p>
          </div>
        </div>
      </div>
      <div id="sub-nav-container">
        <SubNavContainer />
      </div>
      <div id="base-page-introduction-container">
        <div id="base-page-introduction-text-container">
          <div id="base-page-introduction-title-container">
            <h2 id="base-page-intro-title"> Introduction </h2>
          </div>
          <p id="base-page-introduction-text-main">
            Apprenticeships serve as an outstanding gateway for individuals
            eager to gain practical experience, hone their skills, and carve out
            a fulfilling career path in the tech industry. These programs
            seamlessly blend on-the-job training with classroom instruction,
            empowering participants to learn, grow, and thrive in a real-world
            environment while building a robust foundation for their future
            careers.
          </p>
        </div>
      </div>
      <div id="sections-container">
        <SectionCard title="Program Listings" />

        {programsData.map((program, index) => (
          <SectionCard
            key={index}
            subtitle={program.subtitle}
            description={program.description}
            website={program.website}
            websiteUrl={program.websiteUrl}
          />
        ))}
      </div>
    </div>
  );
}

export default Apprenticeship;
